import { Descendant } from 'slate';
import createNamedContext from 'utils/createNamedContext';

export interface ConceptContextValue {
  conceptMap: Record<string, Aide.WhatsAppConceptContent>;
  onCreateConcept: () => void;
  getValue: (editorValue: Descendant[]) => Aide.WhatsAppContent[];
}

export const ConceptContext = createNamedContext<ConceptContextValue | null>(
  'ConceptContext',
  null,
);
